import React from "react";
import "./Recons.css";
import { FaSort, FaSortUp, FaSortDown, FaEye } from "react-icons/fa";
import Pagination from "../../components/Pagination/Pagination";
import {
  formatCurrency,
  formatDate,
} from "../../components/Constants/Constants";
import { useNavigate } from "react-router-dom";
import AppLoader from "../../components/AppLoader/appLoader";
import { useRecons } from "../../customHooks/Recons/useRecons";
import usePermission from "../../utils/usePermission";
import UnAuthorized from "../UnAuthorized/UnAuthorized";
import CopyIcon from "../../components/CopyIcon/CopyIcon";

const Recons = () => {
  const {
    recons,
    loading,
    totalOrderCount,
    filters,
    setFilters,
    handleFilterChange,
    clearFilters,
    sortConfig,
    handleSort,
    paginatedRecons,
    totalPages,
    currentPage,
    startItem,
    endItem,
    goToPage,
    itemsPerPage,
    setItemsPerPage,
    itemsPerPageOptions,
    handleItemsPerPageChange,
    filterOptions, // Include dynamic filters
    selectedOption,
    setSelectedOption,
    searchValue,
    setSearchValue,
    handleDropdownChange,
    handleSearchChange,
    searchOptions,
    handleReconRaise,
  } = useRecons();

  const canRaiseRecon = usePermission("RAISE_RECON_ACCESS");

  const navigate = useNavigate();
  return (
    <>
      {canRaiseRecon ? (
        <div>
          <div className="d-flex justify-content-end align-items-center mt-2">
            {/* <button
          className="btn btn-primary d-flex align-items-center"
          style={{ padding: "4px 8px", fontSize: "14px" }}
          onClick={handleReconRaise}
        >
          Raise Recon
        </button> */}
          </div>

          <div className="filters-wrapper bg-white px-3 py-2 rounded shadow-sm">
            <div className="row gx-4 gy-3 align-items-end flex-wrap">
              {/* Search Section */}
              <div className="col-auto">
                <label
                  className="form-label mb-1"
                  style={{ fontSize: "0.8rem" }}
                >
                  Search By
                </label>
                <div className="d-flex align-items-center">
                  <select
                    className="form-select"
                    value={selectedOption}
                    onChange={handleDropdownChange}
                    style={{
                      width: "150px",
                      borderTopRightRadius: "0",
                      borderBottomRightRadius: "0",
                    }}
                  >
                    {searchOptions?.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <input
                    type="text"
                    className="form-control"
                    value={searchValue}
                    onChange={handleSearchChange}
                    placeholder={`${selectedOption
                      .split("_")
                      .map(
                        (word) => word.charAt(0).toUpperCase() + word.slice(1)
                      )
                      .join(" ")}`}
                    style={{
                      width: "200px",
                      borderTopLeftRadius: "0",
                      borderBottomLeftRadius: "0",
                    }}
                  />
                </div>
              </div>

              <div className="col-auto">
                <label
                  className="form-label mb-1"
                  style={{ fontSize: "0.8rem" }}
                >
                  Recon Type
                </label>
                <select
                  className="form-select"
                  value={filters.recon_type || ""}
                  onChange={(e) =>
                    handleFilterChange("recon_type", e.target.value)
                  }
                  style={{ minWidth: "140px" }}
                >
                  <option value="">All</option>
                  {filterOptions?.reconType?.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>

              {/* Settlement Status */}
              <div className="col-auto">
                <label
                  className="form-label mb-1"
                  style={{ fontSize: "0.8rem" }}
                >
                  Recon Status
                </label>
                <select
                  className="form-select"
                  value={filters.recon_status || ""}
                  onChange={(e) =>
                    handleFilterChange("recon_status", e.target.value)
                  }
                  style={{ minWidth: "120px" }}
                >
                  <option value="">All</option>
                  {filterOptions?.reconStatuses?.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-auto">
                <label
                  className="form-label mb-1.5"
                  style={{ fontSize: "0.8rem" }}
                >
                  Recon Created Between
                </label>
                <div className="d-flex flex-wrap gap-3">
                  {/* FROM Date */}
                  <div
                    className="position-relative"
                    style={{ minWidth: "130px" }}
                  >
                    <label
                      style={{
                        position: "absolute",
                        top: "-10px",
                        left: "10px",
                        background: "#fff",
                        fontSize: "0.7rem",
                        padding: "0 4px",
                        zIndex: 1,
                        color: "#6c757d",
                      }}
                    >
                      From
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      value={filters.recon_created_at_from}
                      onChange={(e) =>
                        handleFilterChange(
                          "recon_created_at_from",
                          e.target.value
                        )
                      }
                    />
                  </div>

                  {/* TO Date */}
                  <div
                    className="position-relative"
                    style={{ minWidth: "130px" }}
                  >
                    <label
                      style={{
                        position: "absolute",
                        top: "-10px",
                        left: "10px",
                        background: "#fff",
                        fontSize: "0.75rem",
                        padding: "0 4px",
                        zIndex: 1,
                        color: "#6c757d",
                      }}
                    >
                      To
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      value={filters.recon_created_at_to}
                      onChange={(e) =>
                        handleFilterChange(
                          "recon_created_at_to",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </div>
              </div>

              {/* Clear Filters Button */}
              <div className="col-auto">
                <button
                  type="button"
                  className="clearFilter d-flex align-items-center"
                  onClick={clearFilters}
                >
                  <i className="bi bi-x-circle me-1"></i>
                  Reset Filters
                </button>
              </div>
            </div>
          </div>

          {loading ? (
            <AppLoader />
          ) : (
            <>
              <div
                className="table-responsive mt-4"
                style={{ overflowX: "auto" }}
              >
                <table
                  className="table table-bordered table-hover align-middle"
                  style={{ minWidth: "1200px" }}
                >
                  <thead className="table-light">
                    <tr>
                      <th style={{ minWidth: "150px" }}>Recon Txn. ID</th>
                      <th style={{ minWidth: "150px" }}>Recon Message ID</th>
                      <th style={{ minWidth: "150px" }}>Order ID</th>
                      <th
                        style={{ minWidth: "100px" }}
                        onClick={() => handleSort("order_amount")}
                        role="button"
                      >
                        Order Amt &nbsp;
                        {sortConfig.key === "order_amount" ? (
                          sortConfig.direction === "asc" ? (
                            <FaSortUp size={14} />
                          ) : (
                            <FaSortDown size={14} />
                          )
                        ) : (
                          <FaSort size={14} />
                        )}
                      </th>
                      <th
                        style={{ minWidth: "100px" }}
                        onClick={() => handleSort("difference_amount")}
                        role="button"
                      >
                        Difference Amt &nbsp;
                        {sortConfig.key === "difference_amount" ? (
                          sortConfig.direction === "asc" ? (
                            <FaSortUp size={14} />
                          ) : (
                            <FaSortDown size={14} />
                          )
                        ) : (
                          <FaSort size={14} />
                        )}
                      </th>
                      <th style={{ minWidth: "100px" }}>Recon Type</th>
                      <th style={{ minWidth: "150px" }}>Status</th>

                      <th
                        style={{ minWidth: "150px" }}
                        onClick={() => handleSort("updatedAt")}
                        role="button"
                      >
                        Updated At &nbsp;
                        {sortConfig.key === "updatedAt" ? (
                          sortConfig.direction === "asc" ? (
                            <FaSortUp size={14} />
                          ) : (
                            <FaSortDown size={14} />
                          )
                        ) : (
                          <FaSort size={14} />
                        )}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedRecons && paginatedRecons.length > 0 ? (
                      paginatedRecons?.map((recon, index) => (
                        <tr key={`${recon.recon_transaction_id}-${index}`}>
                          <td
                            className="copy-cell"
                            style={{ minWidth: "150px" }}
                          >
                            <span
                              onClick={() =>
                                navigate(
                                  `/recons-detail/${recon.recon_transaction_id}`
                                )
                              }
                              style={{
                                cursor: "pointer",
                                color: "#0d6efd", 
                                fontWeight: 500,
                                textDecoration: "none",
                              }}
                              title="View recons Details"
                              className="truncate-cell"
                            >
                              {recon.recon_transaction_id}
                            </span>
                            <CopyIcon textToCopy={recon.recon_transaction_id} />{" "}
                            {/* <-- Added Copy Icon */}
                          </td>

                          <td
                            className="copy-cell"
                            style={{ minWidth: "150px" }}
                          >
                            <span className="truncate-cell">
                              {recon.message_id}
                            </span>
                            <CopyIcon textToCopy={recon.message_id} />
                          </td>
                          <td
                            className="copy-cell"
                            style={{ minWidth: "150px" }}
                          >
                            <span className="truncate-cell">
                              {recon.order_id}
                            </span>
                            <CopyIcon textToCopy={recon.order_id} />
                          </td>

                          <td style={{ minWidth: "100px" }}>
                            {formatCurrency(recon.order_amount)}
                          </td>
                          <td style={{ minWidth: "100px" }}>
                            {formatCurrency(recon.difference_amount)}
                          </td>
                          <td style={{ minWidth: "100px" }}>
                            {recon.recon_type}
                          </td>
                          <td style={{ minWidth: "150px" }}>
                            {recon.recon_status}
                          </td>

                          <td style={{ minWidth: "150px" }}>
                            {formatDate(recon.last_updated)}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={11}
                          className="text-center py-4 text-gray-500"
                        >
                          No Recons Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </>
          )}

          {totalOrderCount > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              startItem={startItem}
              endItem={endItem}
              totalItems={totalOrderCount}
              itemsPerPage={itemsPerPage}
              onItemsPerPageChange={handleItemsPerPageChange}
              onPageChange={goToPage}
              itemsPerPageOptions={itemsPerPageOptions}
            />
          )}
        </div>
      ) : (
        <UnAuthorized />
      )}
    </>
  );
};

export default Recons;
